import { beastStatusAtom } from '@realtime';
import { useAtomValue } from 'jotai';

import { Box, ElvaLogo, Heading2 } from '@ui';

import { uiBeastStatusAtom } from '../../store/status';

import { ParameterRegistrationList } from './ParameterRegistrationList';
import * as css from './styles.css';

const STATUS_LABEL: Record<string, string> = {
    LIVE_FEEDBACK_WAITING_FOR_BALL: 'Waiting for Ball',
    LIVE_FEEDBACK_WAITING_FOR_P1: 'Ready for P1',
    LIVE_FEEDBACK_ACTIVE: 'Active',
    LIVE_FEEDBACK_WAITING_FOR_CONFIG: 'Waiting for Config',
    LIVE_FEEDBACK_WAITING_FOR_TARE: 'Press start to begin',
};

export const LiveActivitySidebar = () => {
    const statusLabel = useAtomValue(beastStatusAtom);
    const beastStatus = useAtomValue(uiBeastStatusAtom);

    return (
        <div className={css.sidebar}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="center"
                flex={1}
                className={css.sidebarWrapper}
            >
                <ParameterRegistrationList />
                <Box paddingBlock={16}>
                    <ElvaLogo width={112} status={beastStatus} />
                    <Heading2 textAlign="center" pt={16}>
                        {STATUS_LABEL[statusLabel]}
                    </Heading2>
                </Box>
            </Box>
        </div>
    );
};
